import SidebarBookingsRepliesRoute from 'uplisting-frontend/pods/-sidebar/bookings/replies/route';

export default class ProtectionOverviewBookingsRepliesRoute extends SidebarBookingsRepliesRoute {}
